<template>
    <div 
        class="p-4 border-t border-r border-dashed border-pale-grey first:bg-red-100"
        :class="`list-${slug} ${classes}`">
        <featured-media-component
            size="medium"
            :media="article.featured_media"
            :link="ARTICLE_LINK(slug, article)"
            :short-headline="article.title"
            class="w-116px h-116px sm:w-full sm:h-174px bg-cover bg-center flex-shrink-0" />

        <div class="py-4 sm:h-163px flex flex-col justify-between flex-grow">
            <a
                :href="ARTICLE_LINK(slug, article)"
               class="flex flex-col justify-between flex-grow">
                <div>
                    <p class="text-waheed text-lg text-black-two leading-8 sm:leading-10 sm:text-22px">{{ article.short_headline }}</p>
                </div>
                <article-meta-component
                    :article="article" />
            </a>
        </div>
    </div>
</template>

<script>
import ArticleMetaComponent from '../../../Layout/ArticleMetaComponent.vue'
import FeaturedMediaComponent from '../../../Layout/FeaturedMedia/FeaturedMediaComponent.vue'

export default{
    props: {
        article: {
            type: Object,
        },
        slug: {
            type: String,
        },
        classes: {
            type: String,
            default: '',
        }
    },
    components: {
        FeaturedMediaComponent,
        ArticleMetaComponent
    }
}
</script>
